import { useState, useEffect } from 'react';
import imageLoading from './imageLoading';
import { formManager, fillForm } from '../../config/configuration/react';
import checkImagePath from './checkImagePath';
// Hook for the state of images components
// store in indexedDB after convert in arrayBuffer
export const useImage = (formIdInit, path, questionId, questionType) => {
  const formId = parseInt(formIdInit, 10);
  const [image, setImage] = useState(null);
  const [_imageId, set_imageId] = useState(null);

  const initImage = async () => {
    const imageId = await fillForm.getValue(formId, path);
    if (!imageId) return;
    set_imageId(imageId);
    setImage(await formManager.getImage(imageId));
  };

  // init the value
  useEffect(() => {
    initImage();
  }, [path]);

  // register image in db.images, and register the imageId in db.forms
  const registerImage = async (newImage) => {
    const maxSize = await checkImagePath(path);
    const imageURL = await imageLoading(newImage, maxSize);
    setImage(imageURL);
    const imageId = await fillForm.saveImage(formId, imageURL, path, questionId, questionType);
    set_imageId(imageId);
  };

  const deleteImage = async () => {
    await fillForm.deleteImage(_imageId);
    await fillForm.saveValue(formId, path, null, questionId, questionType); // to do in fillform directly when on redux
    setImage(null);
  };

  return [image, registerImage, deleteImage];
};
